/**
 *
 * @component 用户中心/数据看板/阶段满意度卡片
 *
 **/

import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { Select } from '&/components/AntdEncapsulation';
import { getItemData } from '@/api/personCenter/dataBoard';
import { barOption } from './constants';
import './StageStatistics.scss';

function StageStatistics(props) {
    const { defaultValue, baseParams = {}, dayOpts, isAdmin = false } = props;

    const [params, setParams] = useState({ div: 4, days: 30 });
    const [data, setData] = useState([]);

    const xAxis = [],
        build = [],
        manager = [],
        design = [];

    let count = 0;

    for (const item of data) {
        xAxis.push(item.name);
        const { number } = item;
        build.push(number.build);
        manager.push(number.manager);
        design.push(number.design);
        count += number.build;
        count += number.manager;
        count += number.design;
    }

    const options = {
        ...barOption,
        xAxis: [
            {
                type: 'category',
                axisTick: { show: false },
                data: xAxis,
            },
        ],
        series: [
            {
                name: '施工结果',
                type: 'bar',
                barGap: '25%',
                barWidth: 12,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: build,
            },
            {
                name: '项目经理',
                type: 'bar',
                barGap: '25%',
                barWidth: 12,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: manager,
            },
        ],
    };

    const canInit = params.days === 30;

    useEffect(() => {
        canInit && setData(defaultValue || []);
    }, [defaultValue]);

    useEffect(() => {
        !canInit && reloadData();
    }, [baseParams.entId]);

    const first = useRef(true);
    useEffect(() => {
        !first.current && reloadData();
        first.current = false;
    }, [params.days]);

    const onChange = (val, key) => {
        setParams(prev => {
            const next = { ...prev };
            return {
                ...next,
                [key]: val,
            };
        });
    };

    function reloadData() {
        const PARAMS = { ...baseParams, ...params };
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data }) => {
            setData(data.getStageOpinion);
        });
    }

    const filterEl = (
        <Select
            value={params.days}
            onChange={e => onChange(e, 'days')}
            options={dayOpts}></Select>
    );

    const HISTORY = useHistory();
    const targetList = () => {
        const path = isAdmin
            ? '/user-center/administrator/stage-satisfaction?days=' +
              params.days
            : '/user-center/manager/stage-satisfaction?days=' + params.days;
        HISTORY.push(path);
    };

    return (
        <BaseCard
            className="stage-statistics"
            title={intl.get('dataBoard.phaseSatisfactionStatistics')}
            headerExtra={filterEl}>
            {count === 0 ? (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            ) : (
                <div onClick={targetList}>
                    <ECharts height="19.75rem" option={options}></ECharts>
                </div>
            )}
        </BaseCard>
    );
}

export default StageStatistics;
